/**
 * The Allow page of a sign-in (Pages/OAuth/Consent.vue) and who the router lets see it.
 *
 * The server renders that page only for a session of the client's own kind: staff for Claude and
 * the staff Annotator, the portal's for a client's Annotator (spec 012). The router must not then
 * hold a client to the staff sign-in, or a client is sent to the login and on to the portal
 * dashboard with no message.
 */

/** Where a client's Allow and Cancel post (routes/oauth.php). Only ever a client's page. */
export const CLIENT_CONSENT_PATH = '/oauth/client/authorize'

/**
 * True when the router shows the page without the staff sign-in: always on the client address;
 * on /oauth/authorize for a plugin's page, or with no page from the server yet (just signed in:
 * Consent.vue reloads once and the server decides). A Claude page keeps the staff check.
 */
export function oauthPageSkipsStaffSignIn(path, served) {
    if (path === CLIENT_CONSENT_PATH) return true

    return !served || !!served.plugin
}
